import type { GraphicHit, ViewHitTestResult } from '@arcgis/core/views/types';
import type { ArcgisMap } from '@arcgis/map-components/components/arcgis-map';

import type { Map2 } from './map-2';

export function HandleViewClick(this: Map2, event: CustomEvent): void {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-argument -- The ArcGIS API is not typed, so we have to cast the event target to the correct type.
  void (event.target as ArcgisMap).hitTest(event.detail).then((response) => {
    applyClickHitTest.call(this, response);
  });
}

function applyClickHitTest(this: Map2, response: ViewHitTestResult): void {
  const _hit = response.results.find(
    (r): r is GraphicHit => r.type === 'graphic' && !r.graphic.isAggregate,
  );
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- The ArcGIS API is not typed, so we have to cast the graphic attributes to the correct type.
  const _id = _hit?.graphic.attributes?.id as string | undefined;

  if (!_id) {
    return;
  }

  this.stateService.selectedListingId.set(_id);
}
